
import { deletePromptCode, getPromptCodeListForSetup } from './actions/PromptCodeActions';
import React, { Component } from 'react';
import PatientPromptCodeModal from './propmt_codes_modal';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { reduxForm, reset } from 'redux-form';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../../actions/utilAction';
import Tooltip from '../../../../../../components/Tooltip';


class ManagePromptCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      promptCodeId: null,
      promptCodeObj: null,
      patientId: props.patientId
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderPromptCodes = this.renderPromptCodes.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.deleted_promptCode && nextProps.deleted_promptCode !== this.props.deleted_promptCode) {
      this.loadData();
    }
    if (nextProps.saved_promptCode && nextProps.saved_promptCode !== this.props.saved_promptCode) {
      this.loadData();
    }


  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { patientId: this.state.patientId || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getPromptCodeListForSetup(searchObj);
  }


  handleOpen() {
    Alert.closeAll();
    this.setState({ open: true, promptCodeId: null, promptCodeObj: null });
  }
  handleClose() {
    this.setState({ open: false });
  };

  handleEditClick = (e, obj) => {
    Alert.closeAll();
    this.setState({
      open: true,
      promptCodeId: obj.id,
      promptCodeObj: obj,
    });
  };

  handleAlertClick = (event, Id) => {
    Alert.closeAll();
    this.props.deletePromptCode(Id);
  };

  handleDeleteClick = (e, obj) => {
    let warningMsg = `Are you sure you want to delete this prompt code?`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  setSortColumn(col_name, col_order) {
    this.filter.sort_Column = col_name;
    this.filter.sort_order = col_order;
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManagePromptCodeform'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.loadData();
  }

  handleSubmitSearch() {
    return false;
  }

  renderPromptCodes = (promptCodeList) => {
    promptCodeList = promptCodeList || [];

    if (!promptCodeList.length) {
      return (
        <tr>
          <td colSpan="8">
            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return promptCodeList.map((data, index) => {
      return (
        <tr key={index}>
          <td>{data.promptCodeName}</td>
          <td>
            {data.abbreviation}
          </td>
          <td className={data.scoreAsIndependent === true ? 'greenfont' : 'redfont'}>{data.scoreAsIndependent === true ? 'Yes' : 'No'}</td>
          <td className={data.dtt === true ? 'greenfont' : 'redfont'}>{data.dtt === true ? 'Yes' : 'No'}</td>
          <td className={data.ta === true ? 'greenfont' : 'redfont'}>{data.ta === true ? 'Yes' : 'No'}</td>
          <td className={data.maintenance === true ? 'greenfont' : 'redfont'}>{data.maintenance === true ? 'Yes' : 'No'}</td>
          <td>{data.peakScore === 0 ? "-" : data.peakScore}</td>          
          <td className={data.isActive === true ? 'greenfont' : 'redfont'}>{data.isActive ? 'Yes' : 'No'}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {this.props.updatePermission ?
                <button onClick={(e) => this.handleEditClick(e, data)} title="Edit" type="button" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                : null
              }
              {this.props.deletePermission ?
                <button onClick={(e) => this.handleDeleteClick(e, data)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  };

  render() {
    const { promptCodeListData } = this.props,
      promptCodeList = (promptCodeListData && promptCodeListData.data) || [],
      promptCodeMeta = (promptCodeListData && promptCodeListData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ?
          <PatientPromptCodeModal
            open={this.state.open}
            patientId={this.state.patientId}
            closeDialog={this.handleClose}
            promptCodeId={this.state.promptCodeId}
            promptCodeObj={this.state.promptCodeObj}
          /> : ''}
            <div className="row mt-3">
              <div className="col-sm-5">
                {this.props.addPermission ?
                  <div>
                    <RaisedButton label="Add Prompt Code" primary={true} onTouchTap={this.handleOpen} /> <Tooltip Description='Customize your own prompt codes by clicking here, and choosing an appropriate name (such as Model Prompt), abbreviation (such as MO), and deciding if this prompt will be scored as an independent (correct) response.' />
                  </div>
                  : null
                }
              </div>
              {/* <div className="col-sm-7">
                <div className="row end-flex">
                  <div className="col-sm-6 mtm-27">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                      <Field
                        name="Name"
                        floatingLabelText="Search"
                        maxLength="10"
                        onChange={this.handleSearchChange}
                        component={renderTextField}
                        fullWidth={true}
                      />
                    </form>
                  </div>
                  <div className="reset-btn col-sm-3 btn_rt">
                    <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="table-responsive mt-15">
              <table className={tableClass}>
                <thead>
                  <tr>
                    <th width="20%">
                      {<SortingCustom noSort={!promptCodeList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Name' />}
                    </th>
                    <th width="15%">
                      {<SortingCustom noSort={!promptCodeList.length} setSortColumn={this.setSortColumn} columnName='abbreviation' displayName='Abbreviation' />}
                    </th>
                    <th width="15%">Score As Independent</th>
                    <th width="10%">DTT</th>
                    <th width="10%">TA</th>
                    <th width="10%">Maintenance</th>
                    <th width="10%">PEAK Score</th>             
                    <th width="5%">Active</th>
                    {this.props.updatePermission || this.props.deletePermission ?
                      <th width="5%">Actions</th>
                      : null
                    }
                  </tr>
                </thead>
                <tbody>
                  {this.renderPromptCodes(promptCodeList)}
                </tbody>
              </table>
            </div>
            {promptCodeMeta && promptCodeMeta['totalPages'] ?
              <PaginatorCustom data={promptCodeMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
              : null
            }
          </div>
    );
  }
}

ManagePromptCode = reduxForm({
  form: 'ManagePromptCodeform',
})(ManagePromptCode);

function mapStateToProps(state) {

   // Start For Role Permission
   let userActionPermission = [];
   if (state.login.userPermission) {
     let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
     let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
     userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
   }
 
   let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 
   let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_PROMPT_CODE")[0].permission : false;
   let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_UPDATE_PROMPT_CODE")[0].permission : false;
   let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_PROMPT_CODE")[0].permission : false;
 
   // End For Role Permission

  return {
    loading: state.patient_prompt_code.loading,
    promptCodeListData: state.patient_prompt_code.promptCodeList,
    deleted_promptCode: state.patient_prompt_code.deleted_promptCode,
    saved_promptCode: state.patient_prompt_code.saved_promptCode,
    addPermission: addPermission, // For Role Permission
    updatePermission: updatePermission, // For Role Permission
    deletePermission: deletePermission, // For Role Permission
  };
}

export default connect(mapStateToProps, { deletePromptCode, getPromptCodeListForSetup })(ManagePromptCode);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/promptCodes/index.js